export class User {
	public userId: string;
	public isActive: boolean;

	constructor(user: User) {
		Object.assign(this, user);
	}
}
